import { TComgateCheckoutConfigBase } from '../types';

export const resolveDebug = (config: TComgateCheckoutConfigBase): boolean => {
    return config.debug === true;
};
